import {Injectable} from "@angular/core";
import {Land} from "../../../models/land/Land";

@Injectable({
  providedIn: 'root'
})
export class PlzValidationHelperService {

  private readonly mapLandToPlzLength : Map<string, number> = new Map<string, number>([
    [Land.DEUTSCHLAND.toUpperCase(),5],
    [Land.NIEDERLANDE.toUpperCase(),7],
    [Land.BELGIEN.toUpperCase(),4],
  ]);

  private readonly mapLandToValidationPattern : Map<string, string> = new Map<string, string>([
    [Land.DEUTSCHLAND.toUpperCase(),'\\d{5}'],
    [Land.NIEDERLANDE.toUpperCase(),'[1-9]\\d{3} [A-Z]{2}|[1-9]\\d{3}[A-Z]{2}'],
    [Land.BELGIEN.toUpperCase(),'(?:(?:[1-9])(?:\\d{3}))'],
  ]);

  private readonly mapLandToPlzPlaceholder : Map<string, string> = new Map<string, string>([
    [Land.DEUTSCHLAND.toUpperCase(),'12345'],
    [Land.NIEDERLANDE.toUpperCase(),'1234 AB'],
    [Land.BELGIEN.toUpperCase(),'1234'],
  ]);

  getMaxPlzLength(land: string) : number {
    return (!!land && this.mapLandToPlzLength.has(land))?
      this.mapLandToPlzLength.get(land) : 10;
  }

  getPlzPattern(land: string) : string {
    return (!!land && this.mapLandToValidationPattern.has(land))?
      this.mapLandToValidationPattern.get(land) : '(.*)';
  }

  getPlzPlaceholder(land: string) : string {
    return (!!land && this.mapLandToValidationPattern.has(land) && this.mapLandToPlzPlaceholder.has(land))?
      this.mapLandToPlzPlaceholder.get(land) : undefined;
  }

}
